"use strict";

var Slick;
if (console.warn) { console.warn("pli/slickgrid is deprecated and will be removed in pli@7.0"); }
Slick = require("slickgrid/core");

Slick.Grid = require("slickgrid/grid");
Slick.AlternateRowSelectionModel = require("./slick.alternaterowselectionmodel");
Slick.AlternateGrouping = require("./slick.alternategrouping");

module.exports = Slick;



//////////////////
// WEBPACK FOOTER
// ./app/slickgrid/index.js
// module id = 522
// module chunks = 49